import { ImageUtils } from '@awayjs/stage';
var MaterialUtils = /** @class */ (function () {
    function MaterialUtils() {
    }
    MaterialUtils.getDefaultTextureMaterial = function () {
        if (!this._defaultTextureMaterial)
            this.createDefaultTextureMaterial();
        return this._defaultTextureMaterial;
    };
    MaterialUtils.getDefaultCubeTextureMaterial = function () {
        if (!this._defaultCubeTextureMaterial)
            this.createDefaultCubeTextureMaterial();
        return this._defaultCubeTextureMaterial;
    };
    MaterialUtils.getDefaultColorMaterial = function () {
        if (!MaterialUtils._defaultColorMaterial)
            MaterialUtils.createDefaultColorMaterial();
        return MaterialUtils._defaultColorMaterial;
    };
    MaterialUtils.createDefaultTextureMaterial = function () {
        this._defaultTextureMaterial = new this._defaultMaterialClass(ImageUtils.getDefaultImage2D());
        this._defaultTextureMaterial.name = 'defaultTextureMaterial';
    };
    MaterialUtils.createDefaultCubeTextureMaterial = function () {
        this._defaultCubeTextureMaterial = new this._defaultMaterialClass(ImageUtils.getDefaultImageCube());
        this._defaultCubeTextureMaterial.name = 'defaultCubeTextureMaterial';
    };
    MaterialUtils.createDefaultColorMaterial = function () {
        this._defaultColorMaterial = new this._defaultMaterialClass(0xFFFFFF);
        this._defaultColorMaterial.name = 'defaultColorMaterial';
    };
    MaterialUtils.setDefaultMaterialClass = function (materialClass) {
        this._defaultMaterialClass = materialClass;
    };
    return MaterialUtils;
}());
export { MaterialUtils };
